<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { RouterLink } from 'vue-router'
import { NXGDSButton } from '@nsftx/seven-nxg-design-system'
import {
  useDmCoreSpaceOperatorStore,
  useOperatorLogin,
} from '@nsftx/seven-client-retail-vue-dm-core'
import { ROUTES_NAMES } from '@/router/routesNames'
import SSFooterDeviceInfo from './footer/components/SSFooterDeviceInfo.vue'

interface MainMenuFooterEmits {
  clickLogout: []
}

const emit = defineEmits<MainMenuFooterEmits>()

const { operatorData } = storeToRefs(useDmCoreSpaceOperatorStore())
const { isLogoutLoading } = useOperatorLogin()

const onLogout = () => {
  emit('clickLogout')
}
</script>

<template>
  <div
    class="ss-main-menu-modal-footer ss-flex-center-between"
    data-testid="ss-main-menu-modal-footer"
  >
    <div class="ss-main-menu-modal-footer__info ss-flex-center">
      <RouterLink v-slot="{ navigate, isActive }" :to="{ name: ROUTES_NAMES.info }" custom>
        <NXGDSButton
          size="md"
          append-icon="info-lucide"
          data-testid="ss-main-menu-modal-footer-info-page"
          :selected="isActive"
          @click="navigate"
        />
      </RouterLink>
      <SSFooterDeviceInfo />
    </div>
    <div class="ss-main-menu-modal-footer__operator ss-flex-center">
      <p v-if="operatorData?.username" class="ss-main-menu-modal-footer__operator__username">
        {{ operatorData.username }}
      </p>
      <NXGDSButton
        size="md"
        append-icon="logout"
        :loading="isLogoutLoading"
        @click="onLogout"
        data-testid="ss-main-menu-modal-footer-logout"
      >
        {{ $t('common_logout') }}
      </NXGDSButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/mixins' as mixins;

.ss-main-menu-modal-footer {
  --ss-main-menu-modal-footer-padding: 8px;

  position: absolute;
  right: var(--ss-main-menu-modal-footer-padding);
  bottom: var(--ss-main-menu-modal-footer-padding);
  left: var(--ss-main-menu-modal-footer-padding);
  padding-top: var(--ss-main-menu-modal-footer-padding);
  background-color: var(--nxgds-mapped-color-surface-component-card-default);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: calc(var(--ss-main-menu-modal-footer-padding) * -1);
    left: calc(var(--ss-main-menu-modal-footer-padding) * -1);
    border-bottom: 1px solid var(--nxgds-mapped-color-border-divider);
  }

  &__info {
    gap: var(--nxgds-alias-spacing-sm);
  }

  &__operator {
    gap: var(--nxgds-alias-spacing-md);

    &__username {
      color: var(--nxgds-mapped-color-text-primary);
      @include mixins.typography('label-medium');
    }
  }
}
</style>
